// Mock data for Arthur Vacogne - ActiV Patrimoine.fr website

export const testimonials = [
  {
    id: 1,
    name: "Marie-Claire D.",
    company: "Particulier - Annecy",
    rating: 5,
    comment: "Accompagnement exceptionnel pour la préparation de ma retraite. Arthur est très professionnel et prend le temps d'expliquer chaque option.",
    date: "2024-12-18",
    source: "google"
  },
  {
    id: 2,
    name: "Jean-François M.", 
    company: "Dirigeant - Haute-Savoie",
    rating: 5,
    comment: "Excellent conseil pour l'optimisation de ma trésorerie d'entreprise. Solutions concrètes et suivi de qualité.",
    date: "2024-12-15",
    source: "google"
  },
  {
    id: 3,
    name: "Sophie L.",
    company: "Particulier - Chambéry", 
    rating: 5,
    comment: "Très satisfaite de l'accompagnement pour mes placements. Conseils clairs et adaptés à ma situation. Je recommande vivement.",
    date: "2024-12-12",
    source: "google"
  },
  {
    id: 4,
    name: "Patrick R.",
    company: "Chef d'entreprise - Annemasse",
    rating: 5,
    comment: "Arthur m'a aidé à restructurer mon épargne. Approche professionnelle et bons conseils. Très content du service.",
    date: "2024-12-10",
    source: "google"
  },
  {
    id: 5,
    name: "Catherine B.",
    company: "Particulier - Thonon",
    rating: 5,
    comment: "Accompagnement personnalisé de qualité. Arthur est à l'écoute et trouve des solutions adaptées. Excellent conseiller.",
    date: "2024-12-08",
    source: "google"
  },
  {
    id: 6,
    name: "Laurent G.", 
    company: "Entrepreneur - Annecy-le-Vieux",
    rating: 5,
    comment: "Conseiller compétent qui m'a accompagné dans mes choix d'investissement. Service professionnel et de confiance.",
    date: "2024-12-05",
    source: "google"
  },
  {
    id: 7,
    name: "Isabelle H.",
    company: "Particulier - Annecy",
    rating: 5,
    comment: "Arthur m'a aidée à optimiser ma fiscalité. Explications très claires et solutions efficaces. Je le recommande.",
    date: "2024-12-02",
    source: "google"
  },
  {
    id: 8,
    name: "Michel T.",
    company: "Dirigeant - Albertville",
    rating: 5,
    comment: "Excellent accompagnement pour la gestion de patrimoine de mon entreprise. Conseils pertinents et suivi régulier.",
    date: "2024-11-28",
    source: "google"
  }
];

export const services = [
  {
    id: 1,
    title: "Particuliers",
    subtitle: "Organiser son épargne, valoriser un capital, optimiser sa fiscalité",
    description: "Une approche personnalisée par objectifs avec une démarche en 2 à 3 rendez-vous sans engagement pour construire ensemble votre stratégie patrimoniale.",
    features: [
      "Approche par objectifs personnalisés",
      "Solutions haut de gamme accessible à tous",
      "2 à 3 rendez-vous sans engagement",
      "Optimisation fiscale particulier",
      "Accessible dès 50€"
    ],
    icon: "Users",
    detailedContent: {
      title: "Donnez du sens à votre argent",
      subtitle: "Vous avez des projets, mais pas toujours le temps ni la visibilité pour faire les bons choix.\nJe vous accompagne pour structurer, optimiser et faire évoluer votre patrimoine simplement.\n\nQuel que soit votre niveau de revenus, ma mission en tant que conseiller en gestion de patrimoine est de démocratiser l'accès à des stratégies d'investissement personnalisées qui sont avant tout au service de vos projets.",
      points: [
        "Bilan patrimonial offert et personnalisé",
        "Placement financier adapté à votre profil",
        "Stratégies d'investissement sur-mesure",
        "Optimisation fiscale et épargne retraite",
        "Accompagnement sans engagement"
      ]
    }
  },
  {
    id: 2,
    title: "Dirigeants & Société", 
    subtitle: "Solutions patrimoniales professionnelles et épargne salariale",
    description: "Optimisation de la trésorerie d'entreprise, accompagnement des dirigeants et mise en place d'épargne salariale pour vos collaborateurs.",
    features: [
      "Valorisation trésorerie d'entreprise",
      "Stratégie patrimoniale dirigeant",
      "Optimisation fiscale entreprise",
      "Prévoyance et homme clé",
      "Accompagnement épargne salariale"
    ],
    icon: "Building",
    detailedContent: {
      title: "Optimisez votre rémunération et votre trésorerie",
      subtitle: "Votre entreprise génère de la valeur, encore faut-il l'exploiter efficacement.\nJe vous aide à structurer vos flux pour optimiser fiscalité, revenus et développement avec des solutions de placement financier adaptées aux entreprises.",
      points: [
        "Arbitrage rémunération / dividendes / épargne",
        "Prévoyance et Hommes clés",
        "Optimisation trésorerie d'entreprise", 
        "Investissement immobilier professionnel",
        "Stratégies patrimoniales dirigeant"
      ]
    }
  },
  {
    id: 3,
    title: "Comités d'Entreprise",
    subtitle: "Formation gratuite et accompagnement pédagogique",
    description: "Cette démarche est gratuite et s'inscrit dans une logique d'écoute, d'information et de pédagogie. L'objectif est de répondre à des questions concrètes que rencontrent de nombreux actifs et leur permettre d'avoir une visibilité globale.",
    features: [
      "Formations gratuites en entreprise",
      "Démarche d'écoute et pédagogie",
      "Réponses aux questions concrètes",
      "Visibilité globale pour les actifs"
    ],
    icon: "Presentation",
    detailedContent: {
      title: "Un avantage concret pour vos collaborateurs",
      subtitle: "Apportez à vos équipes un accompagnement utile et accessible à tous.\nJ'interviens pour les aider à mieux gérer leur budget, leur épargne et leurs projets de vie. Formations en gestion de patrimoine sur des sujets clés : épargne, fiscalité, retraite, transmission.",
      points: [
        "Ateliers pédagogiques (budget, épargne, retraite…)",
        "Accompagnement individuel des salariés",
        "Solutions concrètes en placement financier",
        "Formation gestion de patrimoine accessible",
        "Sans engagement ni coût pour l'entreprise"
      ]
    }
  }
];

export const objectives = [
  "Organiser votre budget",
  "Préparer les études des enfants",
  "Optimiser votre fiscalité",
  "Générer des revenus complémentaires",
  "Préparer et sécuriser votre retraite",
  "Anticiper la transmission familiale",
  "Diversifier vos placements",
  "Valoriser votre trésorerie",
  "Renégociation assurance de prêt",
  "Investir dans l'Immobilier"
];

export const companyInfo = {
  name: "Arthur Vacogne - ActiV Patrimoine.fr",
  fullName: "Arthur Vacogne - Conseiller en Investissements",
  phone: "06 89 30 02 92",
  email: "arthur.vacogne@gmail.com",
  address: "Annecy, Haute-Savoie",
  calendlyUrl: "https://calendly.com/arthur-vacogne-rdv/rdv-echange-1er-prise-de-contact",
  googleReviewUrl: "https://g.page/r/CVcEwDxwGAt0EBM/review",
  googleAllReviewsUrl: "https://www.google.com/search?q=google+my+business+arthur+vacogne+&sca_esv=5aba584b8a922c2c&biw=1707&bih=811&sxsrf=ANbL-n7T3jKo6LXJQvqC6GAG5QDt_EllgQ%3A1774389066435&ei=SgfDabGSGtX0i-gPjtPlsAs&ved=0ahUKEwix3_2vwrmTAxVV-gIHHY5pGbYQ4dUDCBE&uact=5&oq=google+my+business+arthur+vacogne+&gs_lp=Egxnd3Mtd2l6LXNlcnAiImdvb2dsZSBteSBidXNpbmVzcyBhcnRodXIgdmFjb2duZSAyBBAjGCcyBRAAGO8FMgUQABjvBTIFEAAY7wUyBRAAGO8FMgUQABjvBUjhFlDuBVi3CnABeACQAQCYAXegAdICqgEDMy4xuAEDyAEA-AEBmAIFoALmAsICCBAAGLADGO8FwgIIEAAYgAQYogSYAwCIBgGQBgWSBwM0LjGgB64VsgcDMy4xuAfiAsIHBTAuMy4yyAcOgAgA&sclient=gws-wiz-serp",
  description: "Conseiller en investissements indépendant et expert en gestion de patrimoine basé à Annecy, intervenant partout en France."
};

export const aboutContent = {
  mission: "Vous accompagner dans la durée, étape après étape, pour organiser, valoriser et optimiser vos finances personnelles ou professionnelles avec une approche totalement différente des approches traditionnelles et bancaires.",
  experience: "Fort d'une expérience de 20 ans sur les marchés boursiers et 10 ans dans le secteur de la construction",
  approach: "Simple, transparente et accessible à tous : pas de frais cachés, pas de minimum d'investissement. Je souhaite démocratiser la gestion de patrimoine avec une méthode basée sur vos objectifs de vie.",
  process: {
    title: "Accompagnement & Déroulement simple",
    discovery: "Découverte de vos objectifs : nous prendrons le temps d'échanger ensemble sur chacun de vos objectifs à l'aide d'un outil ludique. L'enjeu pour vous ? L'occasion de prendre le temps d'aborder des sujets que vous n'avez peut-être pas le temps d'évoquer au quotidien.",
    understanding: "L'enjeu pour moi ? Comprendre votre fonctionnement, ce qui vous tient à cœur et la nature et la raison de vos objectifs afin de dresser une stratégie patrimoniale totalement personnalisée adaptée à vos envies.",
    presentation: "Restitution & Conseils : nous aborderons la phase de restitution durant laquelle je vous présenterai les solutions retenues en adéquation avec votre profil et votre situation."
  },
  pillars: [
    {
      title: "Accessibilité",
      description: "Des solutions adaptées à tous, sans barrière budgétaire"
    },
    {
      title: "Simplicité", 
      description: "Rendre clairs des sujets souvent complexes"
    },
    {
      title: "Accompagnement",
      description: "Être présent à chaque étape de votre vie patrimoniale"
    }
  ]
};